import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ListItemModule } from '@portal-core/ui/list/directives/list-item/list-item.module';
import { ShowMoreModule } from '@portal-core/ui/list/directives/show-more/show-more.module';
import { AvatarsListComponent } from './avatars-list.component';

@NgModule({
  declarations: [
    AvatarsListComponent
  ],
  imports: [
    CommonModule,
    ListItemModule,
    MatButtonModule,
    MatIconModule,
    MatTooltipModule,
    ShowMoreModule
  ],
  exports: [
    AvatarsListComponent,
    ListItemModule,
    ShowMoreModule
  ]
})
export class AvatarsListModule { }
